<template>
<div class="project-update-assignement">
  <div class="grid-2 has-gutter-xl">
    <div>
      <form class="assign_user" @submit.prevent="assignUser">
        <field type="select" :collection="users" model="project" v-can="'projects.options'" name="user_to_assign" :params="{ no_i18n: true}" v-model="user_to_assign"></field>
        <div class="actions">
          <button type="submit" class="btn btn-primary">{{$t('ui.pages.project-assign')}}</button>
        </div>
      </form>
      <collection @itemDelete="unassignUser" :data="assigned_users" :structure="user_structure" model="user" v-can="'projects.options'"></collection>
    </div>
    <div>
      <form class="assign_businesskit" @submit.prevent="assignBusinesskit">
        <field type="select" :collection="businesskits" model="project" v-can="'projects.options'" name="businesskit_to_assign" :params="{ no_i18n: true}" v-model="businesskit_to_assign"></field>
        <div class="actions">
          <button type="submit" class="btn btn-primary">{{$t('ui.pages.project-assign')}}</button>
        </div>
      </form>
      <collection @itemDelete="unassignBusinesskit" :data="assigned_businesskits" :structure="businesskit_structure" model="business_kit" v-can="'projects.options'"></collection>
    </div>
  </div>
  <div class="update-form--actions">
    <button class="btn btn-primary" @click="finish()" type="submit" data-action="project.update">{{ $t('ui.pages.project-' + type + '-button') }}</button>
  </div>
</div>
</template>
<script>
import Api from '@/api/Project.js'
import OrganizationApi from '@/api/Organization.js'
import UserApi from '@/api/User.js'
import BusinessKitApi from '@/api/BusinessKit.js'

import LeadMaskApi from '@/api/LeadMask'

import {updateMixin} from '@/components/mixins/Update'
import Permission from '@/classes/Permission'
import Collection from '@/components/helpers/DataDisplay/Collection'
import Ui from '@/classes/Ui'


let user_structure = [
  { name: 'id', credentials: "is_root"},
  { name: 'firstname' },
  { name: 'lastname' },
  { name: 'email', sortable: true },
  { name: 'action', type: 'unassign', exclude: ['show'] }
]

let businesskit_structure = [
  { name: 'id', credentials: 'root' },
  { name: 'name', sortable: true },
  { name: 'action', type: 'unassign', exclude: ['show'] }
]

export default {
  mixins: [updateMixin],
  components: { Collection, Ui },
  data(){
    return {
      model: "projects",
      api: new Api(),
      organizations: [],
      lead_masks: [],
      name: "project",
      users: [],
      assigned_users: [],
      user_to_assign: 0,
      businesskits: [],
      assigned_businesskits: [],
      businesskit_to_assign: 0,
      user_structure,
      businesskit_structure
    }
  },
  computed: {
    title(){
      return "ui.pages.project-create";
    }
  },
  methods: {
    finish(){
      this.$router.push({name: 'projects'})
    },
    retrieve_associations(){
      let permission = Permission.loadPermissions()

      if(Permission.can(permission, 'organizations.list')){
        let api = new OrganizationApi()
        api.all_for_association().then((items) => {
          this.organizations = items
        }).catch(function(error) {
          console.log(error)
        })
      }

      if(Permission.can(permission, 'lead_masks.list')){
        let api = new LeadMaskApi()
        api.all_for_association().then((items) => {
          this.lead_masks = items
        }).catch(function(error) {
          console.log(error)
        })
      }

    },
    retrieveUsers(){
      let api = new UserApi()
      api.all_for_association("email", {organization_id: this.item.organization_id}).then((items) => {
        this.users = items
      })
    },
    retrieveAssignedUsers(){
      let api = new UserApi()
      api.all({project_id: this.id}).then((items) => {
        this.assigned_users = items.resources
      })
    },
    unassignUser(item){
      let api = new Api()
      api.unassign_user(item.id, this.id).then((item) => {
        this.retrieveAssignedUsers()
      })
    },
    assignUser(item){
      let api = new Api()
      api.assign_user(this.user_to_assign, this.id).then((item) => {
        this.retrieveAssignedUsers()
        this.user_to_assign = 0
      })
    },
    retrieveBusinesskits(){
      let api = new BusinessKitApi()
      api.all_for_association().then((items) => {
        this.businesskits = items
      })
    },
    retrieveAssignedBusinesskits(){
      let api = new BusinessKitApi()
      api.all({project_id: this.id}).then((items) => {
        this.assigned_businesskits = items.resources
      })
    },
    unassignBusinesskit(item){
      let api = new Api()
      api.unassign_businesskit(item.id, this.id).then((item) => {
        this.retrieveAssignedBusinesskits()
      })
    },
    assignBusinesskit(item){
      let api = new Api()
      api.assign_businesskit(this.businesskit_to_assign, this.id).then((item) => {
        this.retrieveAssignedBusinesskits()
        this.businesskit_to_assign = 0
      }).catch((error) => {
      })
    }
  },
  watch: {
    errors (errors){
      this.error = undefined
      this.errors.forEach((error) => {
        if(error.field_name == "start_date"){
          this.start_date_error = this.$t(error.code)
        }
        if(error.field_name == "end_date"){
          this.end_date_error = this.$t(error.code)
        }
      })
    },
  },
  mounted() {
    this.retrieve_associations()
    this.retrieveUsers()
    this.retrieveAssignedUsers()
    this.retrieveBusinesskits()
    this.retrieveAssignedBusinesskits()
  }
}


</script>
<style>
.update-form--actions {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// ProjectUpdateAssignement.vue?a235cd22